"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const d3updatePattern_1 = require("../layerstack/d3updatePattern");
class LabelLayer {
    constructor(view, args) {
        this.update = {
            parent: () => this.attach(),
            data: () => {
                this.d3updatePattern.update.data();
                this.d3updatePattern2.update.data();
            },
            transformation: () => {
                this.d3updatePattern.update.transformation();
                this.d3updatePattern2.update.transformation();
            },
            style: () => {
                this.d3updatePattern.update.style();
                this.d3updatePattern2.update.style();
            }
        };
        this.view = view;
        this.args = args;
        this.name = args.name;
    }
    attach() {
        this.d3updatePattern = new d3updatePattern_1.D3UpdatePattern({
            parent: this.view.parent,
            layer: this,
            clip: this.args.clip,
            data: this.args.data,
            name: this.name,
            className: this.args.className,
            elementType: 'text',
            create: s => s.classed("P", d => d.name == 'P')
                .classed("caption-icon", d => d.precalc.icon && navigator.platform.includes('inux'))
                //.style("fill",           d=> d.pathes.finalcolor)
                .style("stroke", d => d.pathes && d.pathes.labelcolor)
                .text(this.args.text),
            updateColor: s => s.style("stroke", d => d.pathes && d.pathes.labelcolor),
            updateTransform: s => s.attr("transform", (d, i, v) => this.args.transform(d, this.args.delta(d, i, v)))
            //                         .text(                   this.args.text)
        });
        this.d3updatePattern2 = new d3updatePattern_1.D3UpdatePattern({
            parent: this.view.parent,
            layer: this,
            clip: this.args.clip,
            data: [],
            name: 'label-link',
            className: 'label-link',
            elementType: 'line',
            create: s => { },
            updateColor: s => { },
            updateTransform: s => s.attr('x1', d => d.forcepoints.x || 0)
                .attr('y1', d => d.forcepoints.y || 0)
                .attr('x2', d => d.forcepoints2.x || 0)
                .attr('y2', d => d.forcepoints2.y || 0)
                .attr("stroke-width", d => .002)
                .attr("stroke-linecap", d => "round")
        });
    }
}
exports.LabelLayer = LabelLayer;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/layers/label-layer.js
// module id = 79
// module chunks = 0